import React, { Component } from 'react';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import HeaderShopProps from './HeaderShop.props';
import HeaderShopState from './HeaderShop.state';

export default class HeaderShop extends Component<HeaderShopProps, HeaderShopState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;
    
    constructor(props: HeaderShopProps) {
        super(props);
        this.state = {
            fixed: this.props.fixed || false
        };
    }

    render(): React.ReactNode {
        return (
            <header className={`header-shop${this.props.fixed ? ' header-shop--fixed' : ''}`}>
                <div className="container header-shop__container">
                    <a className="header-shop__logo-link" href={this.context.i18nProvider.get('headerShop.link')}>
                        <img className="header-shop__logo" 
                            src={this.context.i18nProvider.get('headerShop.imageSrc')} 
                            alt={this.context.i18nProvider.get('headerShop.imageAlt')} />
                    </a>
                </div>
            </header>
        );
    }
}
